import {
  IArchiveAccount,
  ICheckAccountExist,
  ICreateAccount,
  IEditAccount,
  IGetAccountById,
  IGetAccountByUser,
  IGetExportUsersPayload,
  IGetUsersPayload,
  IMakeAccountActive,
  TDataUsersResponse,
  TExportDataUsersResponse,
} from '../models/accountSetup.model'
import { ApiResponse } from '../models/common.model'
import customAxios from '../utils/api-util/customAxios'
import axiosInstance from '../utils/api-util/utilApi'

const config = { baseURL: process.env.REACT_APP_CLIENT_SETUP_SERVICE_URL || '' }

export const createAccount = (payload: ICreateAccount.Payload): Promise<ApiResponse<ICreateAccount.Response>> => {
  return axiosInstance.post(`/accounts/create`, JSON.stringify(payload), config)
}

export const makeAccountActive = (
  payload: IMakeAccountActive.Payload,
): Promise<ApiResponse<IMakeAccountActive.Response>> => {
  return axiosInstance.post(`/accounts/makeActive`, JSON.stringify(payload), config)
}

export const checkAccountExist = (
  payload: ICheckAccountExist.Payload,
): Promise<ApiResponse<ICheckAccountExist.Response>> => {
  return axiosInstance.post(`/accounts/checkAccountExist`, JSON.stringify(payload), config)
}

export const getExportDataUsers = (payload: IGetExportUsersPayload, id?: string): Promise<TExportDataUsersResponse> => {
  const url = `/accounts/${id}/userList`
  return axiosInstance.post(url, JSON.stringify(payload), config)
}

export const getDataUsers = (payload: Partial<IGetUsersPayload>, id?: string): Promise<TDataUsersResponse> => {
  const url = `/accounts/${id}/userList`
  return axiosInstance.post(url, JSON.stringify(payload), config)
}

export const getAccountById = (payload: IGetAccountById.Payload): Promise<ApiResponse<IGetAccountById.Response>> => {
  return axiosInstance.get(`/accounts/${payload.accountId}`, config)
}

export const editAccount = (payload: IEditAccount.Payload): Promise<ApiResponse<IEditAccount.Response>> => {
  return axiosInstance.put(`/accounts/update/${payload.accountId}`, JSON.stringify(payload.data), config)
}

export const archiveAccount = (payload: IArchiveAccount.Payload): Promise<ApiResponse<IArchiveAccount.Response>> => {
  return axiosInstance.post(`/accounts/archiveAccount`, JSON.stringify(payload), config)
}

export const getAccountByUser = (
  payload: IGetAccountByUser.Payload,
): Promise<ApiResponse<IGetAccountByUser.Response>> => {
  return axiosInstance.post(`/accounts/accountsByUser`, JSON.stringify(payload), config)
}

export const getClientList = () => {
  return axiosInstance.get(`/api/clients/listClientName`, config)
}

export const getFileAccountTemplate = (clientId: string, isEdit: boolean) => {
  return axiosInstance.get(`/accounts/client/${clientId}/downloadImportingTemplate?isEdit=${isEdit}`, config)
}

export const getccountTemplate = (payload: any) => {
  return axiosInstance.post(`/accounts/template/generate`, JSON.stringify(payload), config)
}

export const postFileAccountTemplate = (clientId: string, isEdit: boolean, formData: any) => {
  return customAxios('multipart/form-data').post(`/accounts/client/${clientId}/import?isEdit=${isEdit}`, formData, {
    ...config,
  })
}

export const postFileAccountUpload = (formData: any) => {
  return customAxios('multipart/form-data').post(`/accounts/upload`, formData, {
    ...config,
  })
}

export const getAccountsDownloadStatus = (fileId: string): Promise<ApiResponse<string>> => {
  return axiosInstance.get(`/accounts/getStatus/${fileId}`, config)
}

export const getAccountsDownloadFile = (fileId: string): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/accounts/downloadPdf/${fileId}`, config)
}
